import {
  Modal as BaseModal,
  Button,
  Center,
  Heading,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import * as React from 'react';

import { Emoji } from '@/imports/ui/chakra/components/Emoji';

import { useCreateUpgradeRequest } from './useCreateUpgradeRequest';

export const Modal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  organizationId: string;
  headerText: string;
  bodyText: string;
  shouldShowUpgradeCTA?: boolean;
  source: string;
  returnFocusOnClose?: boolean;
}> = ({
  isOpen,
  onClose,
  organizationId,
  headerText,
  bodyText,
  shouldShowUpgradeCTA = true,
  source,
  returnFocusOnClose,
}) => {
  const { requestOrganizationUpgrade, loading, submittedUpgrade } =
    useCreateUpgradeRequest(organizationId);

  const handleClick = async (buttonText: string): Promise<void> => {
    await requestOrganizationUpgrade(`${source}: "${buttonText}" button`);
  };

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
      isCentered
      {...(returnFocusOnClose !== undefined ? { returnFocusOnClose } : {})}
    >
      <ModalOverlay />
      <ModalContent p="6">
        <ModalHeader p="0" textAlign="center">
          <Emoji
            label={submittedUpgrade ? 'check mark' : 'old key'}
            symbol={submittedUpgrade ? '✅' : '🗝️'}
            fontSize="4xl"
            lineHeight="normal"
          />

          <Heading as="h4" size="md" mt="5">
            {submittedUpgrade ? 'We’ll Be in Touch Soon!' : headerText}
          </Heading>
        </ModalHeader>

        <ModalBody color="gray.500" pt="2" pb="6" px="0" textAlign="center">
          {submittedUpgrade
            ? `Our team has been notified of your interest and someone will be in touch with you soon!`
            : bodyText}
        </ModalBody>

        {!submittedUpgrade && (
          <Center>
            <ModalFooter p="0">
              {shouldShowUpgradeCTA ? (
                <>
                  <Button
                    colorScheme="gray"
                    variant="outline"
                    mr="4"
                    isLoading={loading}
                    onClick={() => handleClick('Contact us to learn more')}
                  >
                    Contact Us to Learn More
                  </Button>

                  <Button
                    isLoading={loading}
                    onClick={() => handleClick('Upgrade now')}
                  >
                    Upgrade Now
                  </Button>
                </>
              ) : (
                <Button onClick={onClose}>Got it</Button>
              )}
            </ModalFooter>
          </Center>
        )}
      </ModalContent>
    </BaseModal>
  );
};
